import { useState } from 'react';
import { SunIcon, MoonIcon } from '../Icons/Icons.js';
import './ThemeToggle.sass';

// public/index.html sets data-theme before React loads, so we start in sync with it.
function getInitialTheme() {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
}

function ThemeToggle() {
  const [theme, setTheme] = useState(getInitialTheme);
  const isDark = theme === 'dark';

  function toggle() {
    const next = isDark ? 'light' : 'dark';
    const root = document.documentElement;
    root.classList.add('theme-transition');
    root.dataset.theme = next;
    window.setTimeout(() => root.classList.remove('theme-transition'), 400);
    try {
      localStorage.setItem('theme', next);
    } catch {
      // storage can be blocked (private mode); the toggle still works for this visit
    }
    setTheme(next);
  }

  return (
    <button
      className={`theme_toggle ${isDark ? 'theme_toggle-dark' : ''}`}
      role="switch"
      aria-checked={isDark}
      aria-label="Dark mode"
      onClick={toggle}
    >
      <span className="theme_toggle_knob">
        {isDark ? <MoonIcon width="13" height="13" /> : <SunIcon width="14" height="14" />}
      </span>
    </button>
  );
}

export default ThemeToggle;
